import { render, staticRenderFns } from "./NavigtionFooter.vue?vue&type=template&id=eeb8611c&scoped=true"
import script from "./NavigtionFooter.vue?vue&type=script&lang=js"
export * from "./NavigtionFooter.vue?vue&type=script&lang=js"
import style0 from "./NavigtionFooter.vue?vue&type=style&index=0&id=eeb8611c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb8611c",
  null
  
)

export default component.exports